<template>
    <div>

        <property-toolbar :layout="layout" :layout-type="layoutType"></property-toolbar>

        <div class="card-body p-0">

            <div class="card-header editor-content d-flex">
                <div>
                    Properties
                </div>
            </div>

            <navbar-properties v-if="layoutType === 'header'" :layout="layout"></navbar-properties>
            <row-properties v-if="layout.selectedRow" :layout="layout"></row-properties>
            <column-properties v-if="layout.selectedColumn" :layout="layout"></column-properties>

            <button-properties v-if="layout.selectedComponent && layout.selectedComponent.type === 'Button'"
                               :layout="layout" :page="page"></button-properties>
            <icon-properties v-else-if="layout.selectedComponent && layout.selectedComponent.type === 'Icon'"
                               :layout="layout" :page="page"></icon-properties>
            <component-properties v-else-if="layout.selectedComponent" :layout="layout" :page="page"></component-properties>

        </div>
    </div>
</template>

<script>

    import PageFactory from "../../utils/PageFactory";
    import RowProperties from "../properties/RowProperties.vue";
    import ColumnProperties from "../properties/ColumnProperties.vue";
    import ComponentProperties from "../properties/ComponentProperties.vue";
    import PropertyToolbar from "../properties/PropertyToolbar.vue";
    import NavbarProperties from "../properties/NavbarProperties.vue";
    import ButtonProperties from "../properties/ButtonProperties.vue";
    import IconProperties from "../properties/IconProperties.vue";

    export default {
        name: 'PagePropertyEditor',
        components: {
            IconProperties,
            ButtonProperties,
            NavbarProperties, PropertyToolbar, ComponentProperties, ColumnProperties, RowProperties},
        props: ['layout', 'page', 'layoutType'],
        data() {
            return {
                model: webase.model,
                factory: new PageFactory()
            }
        },
        mounted() {

        }
    }
</script>

<style>

</style>
